import React from 'react'
import LogoQatarImg from "../assets/images/logo-qatar-tourism.svg"
import LogoImg from "../assets/images/logo-blue.svg"
import { LiaFacebookF } from "react-icons/lia";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { BiLogoYoutube, BiLogoTiktok } from "react-icons/bi";
import playStore from "../assets/images/ios.webp"
import appStore from "../assets/images/android.webp"


function Footer() {
    return (
        <footer>
            <div className="container">
                <footer className="row pt-5">
                    <div className="col-lg-3">
                        <a href="/" className="d-flex align-items-center justify-content-lg-start justify-content-center mb-3 link-dark text-decoration-none">
                            <img loading="lazy" width="78" height="70" src={LogoQatarImg} alt="Logo Qatar Tourism" className="logo-qatar" />
                            <img loading="lazy" width="100" height="70" src={LogoImg} alt="Logo Visit Qatar" className="logo-theme" />
                        </a>
                    </div>
                    <div className='col-lg-9 footer-list'>
                        <div className="footer-sub-list footer-img-list">
                            <h5 className='footer-head'>Download our app</h5>
                            <a href="https://play.google.com/store/apps/details?id=qa.visitqatar.app&utm_source=Google+Play+Store+Badge&utm_campaign=website-playstore-badge&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&pli=1" className='footer-img-a'>
                                <img loading="lazy" width="80" height="50" src={appStore} alt="Logo Visit Qatar" className="img-fluid w-100" />
                            </a>
                            <a href="https://apps.apple.com/us/app/visit-qatar/id1556210707?ign-itscg=30200&ign-itsct=apps_box" className='footer-img-a'>
                                <img loading="lazy" width="58" height="50" src={playStore} alt="Logo Qatar Tourism" className="img-fluid w-100" />
                            </a>
                        </div>

                        <div className="footer-sub-list order-2">
                            <h5 className='footer-head'>Qatar Now guide </h5>
                            <ul className="nav flex-column">
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/qatar-now" className="nav-link p-0 text-muted">Latest edition</a></li>
                            </ul>
                        </div>
                        <div className="footer-sub-list order-1">
                            <h5 className='footer-head'>Follow </h5>
                            <ul className="nav row row-cols-lg-1 row-cols-md-2 col-md-6 col-lg-12">
                                <li className="nav-item mb-3">
                                    <a href="https://www.facebook.com/VisitQatar" className="nav-link p-0 text-muted">
                                        <LiaFacebookF className='me-2' size={18} /> Facebook
                                    </a>
                                </li>
                                <li className="nav-item mb-3">
                                    <a href="https://www.instagram.com/visitqatar/" className="nav-link p-0 text-muted">
                                        <FaInstagram className='me-2' size={18} /> Instagram
                                    </a>
                                </li>
                                <li className="nav-item mb-3">
                                    <a href="https://x.com/visitqatar" className="nav-link p-0 text-muted">
                                        <FaXTwitter className='me-2' size={18} /> X
                                    </a>
                                </li>
                                <li className="nav-item mb-3">
                                    <a href="https://www.youtube.com/user/QatarTourism" className="nav-link p-0 text-muted">
                                        <BiLogoYoutube className='me-2' size={18} /> Youtube
                                    </a>
                                </li>
                                <li className="nav-item mb-3">
                                    <a href="https://www.tiktok.com/@visitqatar" className="nav-link p-0 text-muted">
                                        <BiLogoTiktok className='me-2' size={18} /> TikTok
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="footer-sub-list order-3">
                            <h5 className='footer-head'>Contact</h5>
                            <ul className="nav flex-column">
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/contact-us" className="nav-link p-0 text-muted">Contact Us</a></li>
                                <li className="nav-item mb-3"><a href="https://www.qatartourism.com/en/travel-trade/sales-resources/qatar-tourism-media-pack" className="nav-link p-0 text-muted">Media Centre</a></li>
                            </ul>
                        </div>

                        <div className="footer-sub-list order-4">
                            <h5 className='footer-head'>Information</h5>
                            <ul className="nav flex-column">
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/legal/terms-and-conditions" className="nav-link p-0 text-muted">Terms &amp; conditions</a></li>
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/legal/privacy-notice" className="nav-link p-0 text-muted">Privacy notice</a></li>
                                <li className="nav-item mb-3"><a href="https://www.qatartourism.com/en" className="nav-link p-0 text-muted">Corporate website</a></li>
                                <li className="nav-item mb-3"><a href="https://www.diwan.gov.qa/" className="nav-link p-0 text-muted">Amiri Diwan</a></li>
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/legal/cookie-policy" className="nav-link p-0 text-muted">Cookie policy</a></li>
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/branding/logos" className="nav-link p-0 text-muted">Qatar Tourism brand logos</a></li>
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/events-calendar" className="nav-link p-0 text-muted">Subscribe to our newsletter</a></li>
                                <li className="nav-item mb-3"><a href="https://visitqatar.com/intl-en/events-calendar" className="nav-link p-0 text-muted">Cookie Consent</a></li>
                            </ul>
                        </div>
                    </div>
                </footer>
            </div>
        </footer>
    )
}

export default Footer;